module.exports = "<span ng-message=pattern>*Valid website address required </span> ";